<template>
    <div class="indexPage" style="height: 100%;">

        <headfix></headfix>
        <div class="common-banner">
            <div class="bg-img" v-for="(item,index) in advList">
                <img :src="item.advImages" class="pc"/>
                <img :src="item.advSmallImages1" class="mobile"/>
            </div>
        </div>

        <div class="wraper-box" style="position: relative;">
            <div v-html="detail.content" class="content" style="margin-top: 0px; padding-top: 0px; text-align: center; padding-bottom: 20px;"></div>

        </div>

        <footerfix></footerfix>

    </div>
</template>
<script>
    import headfix from '@/components/utils/headfix';
    import footerfix from '@/components/utils/footerfix';

    export default {
        components: {headfix, footerfix},
        data() {
            return {
                advList:[],
                categoryInfo: {},
                detail: {},
                currentId: 0,
            }
        },
        created() {
            this.currentId = this.$route.query.cateId;
            this.$nextTick(() => {
                this.getCategoryData(this.currentId);
                this.getAdvData(64);
                this.getDetail(this.currentId);
            })
        },
        methods: {
            // 分类详情
            getCategoryData(categoryId) {
                this.$post_('api/cms-category/info', {id: categoryId}, (res) => {
                    if (res.code == 1) {
                        this.categoryInfo = res.data;
                    } else {
                        this.$message.error(res.message);
                    }
                })
            },
            // 分类广告
            getAdvData(positionId) {
                this.$post_('api/adv/adv-list', {catId: positionId}, (res) => {
                    if (res.code == 1) {
                        this.advList = res.data;
                    } else {
                        this.$message.error(res.message);
                    }
                })
            },
            // 详情
            getDetail(categoryId) {

                this.$post_('api/cms-article/article-info-by-category-id', {categoryId: categoryId}, (res) => {
                    if (res.code == 1) {
                        this.detail = res.data ? res.data : {};
                    } else {
                        this.$message.error(res.message);
                    }
                })
            }
        }
    }
</script>

<style scoped>


    /*产品中心-筛选*/

    @media (max-width: 1799px) {

    }

    @media (max-width: 1199px) {

    }

    @media (max-width: 993px) {

    }

    @media (max-width: 767px) {


    }


</style>
